/* eslint-disable import/no-extraneous-dependencies */
import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import { parsePhoneNumber, isValidNumberForRegion } from 'libphonenumber-js';
import { IconClose } from 'utils/icon';

const tooltipContent = `
  <div class="body-4 text-gray-900">
    ${window.TMW.Strings.product.backInStockTermsOfServices}${' '}
    <a href="https://attnl.tv/t/eOC">
      ${window.TMW.Strings.product.backInStockTermsOfServicesLink}
    </a>
    ${' & '}
    <a href="https://attnl.tv/t/e0C">
      ${window.TMW.Strings.product.backInStockPrivacyPolicy}
    </a>
  </div>
`;

const NotifyMe = ({
  product = null,
  activeVariant = null,
  classes = null,
  isProductCard = false,
}) => {
  const backInStockDate =
    activeVariant?.metafields?.backInStockDate ||
    product?.variantBySelectedOptions?.metafields?.backInStockDate ||
    activeVariant?.backInStockDate?.value ||
    null;
  const variantId = activeVariant?.id.split('/ProductVariant/')[1] || null;
  const productId = product?.id.split('/Product/')[1] || null;

  const [attentiveSmsSignUpUrl, setattentiveSmsSignUpUrl] = useState(null);
  const [sourceId, setSourceId] = useState(null);
  const [acceptsMarketing, setAcceptsMarketing] = useState(false);
  const [acceptsSms, setAcceptsSms] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    const technicalDataEl = document.querySelector('[data-technical]');
    const data =
      technicalDataEl?.innerHTML && JSON.parse(technicalDataEl.innerHTML);
    if (data) {
      setSourceId(data.sourceId);
      setattentiveSmsSignUpUrl(data.attentiveSmsSignUpUrl);
    }
  }, []);

  const resetForm = () => {
    setEmail('');
    setPhone('');
    setAcceptsMarketing(false);
    setAcceptsSms(false);
    setShowSuccess(false);
    setShowError(false);
  };

  const handleSubscriptionResponse = (resp, onSuccess) => {
    if (resp.status === 'OK') {
      setShowSuccess(true);
      setShowError(false);
      if (onSuccess) onSuccess();
    } else {
      setShowError(true);
    }
  };

  const handleSubscribe = (event) => {
    event.preventDefault();
    setShowSuccess(false);
    setShowError(false);

    if (email && !phone) {
      window.BIS.create(email, variantId, productId, {
        accepts_marketing: acceptsMarketing,
      }).then((resp) => handleSubscriptionResponse(resp));
    } else if (phone && !email) {
      const isValid = isValidNumberForRegion(phone, 'US');
      if (!isValid) {
        setShowError(true);
        return;
      }
      const parsedPhone = parsePhoneNumber(phone, 'US');
      window.BIS.create(null, variantId, productId, {
        phone_number: parsedPhone.number,
      }).then((resp) => {
        handleSubscriptionResponse(resp, () =>
          subscribeToSms(email, parsedPhone.number),
        );
      });
    } else if (phone && email) {
      const isValid = isValidNumberForRegion(phone, 'US');
      if (!isValid) {
        setShowError(true);
        return;
      }
      const parsedPhone = parsePhoneNumber(phone, 'US');
      window.BIS.create(email, variantId, productId, {
        accepts_marketing: acceptsMarketing,
      }).then((resp) => {
        handleSubscriptionResponse(resp, () => {
          window.BIS.create(null, variantId, productId, {
            phone_number: parsedPhone.number,
          }).then((resp2) =>
            handleSubscriptionResponse(resp2, () =>
              subscribeToSms(email, parsedPhone.number),
            ),
          );
        });
      });
    } else {
      setShowError(true);
    }
  };

  function subscribeToSms(backInStockEmail, backInStockPhone) {
    if (!acceptsSms || !sourceId) return;

    const request = {
      user: {
        email: backInStockEmail,
        phone: backInStockPhone,
      },
      signUpSourceId: sourceId,
      locale: {
        language: 'en',
        country: 'US',
      },
      subscriptionType: 'MARKETING',
    };

    fetch(attentiveSmsSignUpUrl, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Accept: 'application/json',
      },
      body: JSON.stringify(request),
    })
      .then((response) => response.json())
      .then((data) => console.log(data))
      .catch((error) => console.error('Error:', error));
  }

  return (
    <form onSubmit={handleSubscribe} className="py-4">
      <div
        className={`${classes} ${showSuccess ? 'hidden' : ''}`}
        data-back-in-stock
      >
        <p className="body-3--medium text-left">
          {window.TMW.Strings.product.backInStockTitle}
        </p>
        <p className="body-3 pb-[16px] text-left" data-back-in-stock-message>
          {backInStockDate && (
            <>
              {window.TMW.Strings.product.backInStockMessage}{' '}
              {backInStockDate || backInStockDate.value}
            </>
          )}
        </p>
        <input
          type="tel"
          placeholder="Phone Number"
          className="body-3 w-full mb-[8px] py-[10px] px-[10px] border border-gray-400 text-gray-900 focus:ring-0
        focus:ring-transparent focus:border focus:border-gray-400"
          pattern="[0-9]*"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email Address"
          className="body-3 w-full mb-[8px] py-[10px] px-[10px] border border-gray-400 text-gray-900 focus:ring-0
        focus:ring-transparent focus:border focus:border-gray-400"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="flex items-center mb-[8px]">
          <input
            type="checkbox"
            id="newsletterCheckbox"
            className="mr-2 text-gray-900
          focus:ring-0 focus:ring-transparent focus:border focus:border-gray-400"
            checked={acceptsMarketing}
            onClick={() => setAcceptsMarketing(!acceptsMarketing)}
          />
          <label htmlFor="newsletterCheckbox" className="body-3 cursor-pointer">
            {window.TMW.Strings.product.backInStockNewsletter}
          </label>
        </div>
        <div
          className="flex items-center pb-[16px] relative"
          data-tooltip-icon-container
        >
          <input
            type="checkbox"
            id="smsCheckbox"
            className="mr-2 text-gray-900
            focus:ring-0 focus:ring-transparent focus:border focus:border-gray-400"
            checked={acceptsSms}
            onClick={() => setAcceptsSms(!acceptsSms)}
          />
          <label
            htmlFor="smsCheckbox"
            className="body-3 cursor-pointer text-ellipsis whitespace-nowrap overflow-hidden"
          >
            {window.TMW.Strings.product.backInStockSmsCheckbox}
          </label>
        </div>
        <div
          className="cursor-pointer bg-core-1 opacity-100"
          data-tooltip-message
        >
          <div
            // eslint-disable-next-line max-len
            className="relative w-full p-4 mb-4 left-1/2 transform -translate-x-1/2 cursor-default"
            dangerouslySetInnerHTML={{ __html: tooltipContent }}
          />
        </div>
        <div
          className={`items-center mb-[16px] ${showError ? 'flex' : 'hidden'}`}
        >
          <p className="body-3 text-sale text-left">
            {window.TMW.Strings.product.backInStockError}
          </p>
        </div>
        <button
          className="button button--primary w-full"
          onClick={handleSubscribe}
          type="submit"
        >
          {window.TMW.Strings.product.backInStockButton}
        </button>
      </div>
      {showSuccess && (
        <div
          className={`bg-gray-100 w-full py-[12px] px-[9px] ${
            isProductCard ? 'absolute bottom-0' : 'relative'
          }`}
        >
          {!isProductCard && (
            <button
              type="button"
              className="absolute top-3 right-2.5"
              onClick={resetForm}
            >
              <IconClose width="10" height="10" />
            </button>
          )}
          <span className="body-3--medium">
            {window.TMW.Strings.product.backInStockSuccessTitle}
          </span>{' '}
          <span className="body-3">
            {window.TMW.Strings.product.backInStockSuccessCopy}
          </span>
        </div>
      )}
    </form>
  );
};

export default NotifyMe;
